
<template>
  <div>
    <v-main>
      <div style="padding-top:15px;">
        <h1 style="text-align: center;">ขอบคุณที่ใช้บริการเรา</h1>
      <h1 style="text-align: center;">กรุณา Login</h1>
      </div>

    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
export default {
  components: {
  },
  data () {
    return {
      form: {
        shopId: ''
      }
    }
  },
  async mounted () {
    console.log(this.$route.query.productName.substring(0, 7))
    if (this.$route.query.state === 'register' && this.$route.query.productName.substring(0, 7) === 'loyalty') {
      await this.getBotLineId()
    } else {
      this.$swal('ผิดพลาด', 'กรุณาติดต่อเจ้าหน้าที่', 'error')
    }
  },
  methods: {
    async getBotLineId () {
      let dt = {
        code: this.$route.query.code,
        redirect_uri: 'https://betask-loyalty-app.web.app/System/ManageShop?productName=' + this.$route.query.productName
      }
      console.log('dt', dt)
      await axios
        .post(
          this.DNS_IP + '/line/linkYourBot',
          dt
        )
        .then(async (response) => {
          console.log('getBotLineId', response.data)
          this.form.shopId = response.data.bot_id
          if (response.data.bot_id) {
            await axios
              .get(
                this.DNS_IP + '/system_shop/get?shopId=' + response.data.bot_id
              )
              .then(async (responses) => {
                if (responses.data.status !== false) {
                  this.$swal('ผิดพลาด', 'Line Oa ที่ท่านเลือกอยู่ใน ระบบแล้ว กรุณา Log In และเพิ่ม User ในระบบ รหัสร้านค้า' + response.data.bot_id, 'error')
                } else {
                  this.getOaLink(this.form.shopId)
                }
              })
              .catch((error) => {
                console.log(error)
                this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
                this.dataReady = true
              })
          }
        })
        .catch((error) => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          this.dataReady = true
        })
    },
    async getOaLink (shopIdDt) {
      console.log('shopIdDt', shopIdDt)
      await axios
        .get(
          this.DNS_IP + '/line/getOa', {
            headers: {
              'botId': shopIdDt
            }
          }
        )
        .then(async (response) => {
          console.log('getOa', response.data)
          this.nameOa = response.data.displayName
          this.form.displayName = response.data.displayName
          if (response.data.pictureUrl) {
            this.form.logo = response.data.pictureUrl
          } else {
            this.form.logo = ''
          }
          var dt = {
            shopId: shopIdDt,
            shopIdOld: this.$route.query.productName.substring(7)
          }
          await axios
            .post(this.DNS_IP + '/system_shop/updateShopId', dt)
            .then(async (response) => {
              window.location = 'https://betask-loyalty-app.web.app/'
            })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async getOaLinkA (shopIdDt) {
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/line/getOa", {
            headers: {
              'botid': shopIdDt
            }
          }
        )
        .then(async (response) => {
          console.log('getOa', response.data)
          this.nameOa = response.data.displayName
          if (response.data.pictureUrl) {
            this.form.logo = response.data.pictureUrl
          } else {
            this.form.logo = ''
          }
          var dt = {
            shopId: shopIdDt,
            shopImge: this.form.logo,
            shopIdOld: this.$route.query.productName.substring(4)
          }
          await axios
            .post(
              this.DNS_IP + '/register/updateShopId', dt
            )
            .then(async (response) => {
            })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          // this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          // this.dataReady = true
        })
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/System/ManageShop.vue